/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "@fontsource/roboto";
import { TDocumentDefinitions } from 'pdfmake/interfaces';


pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
/** REINDERIZAÇÃO DE IMAGEM, PARA CONVERÇÃO **/
function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function abreviarNome(nome: string) {
    if (typeof nome !== 'string' || !nome.trim()) {
        throw new Error('Nome inválido');
    }

    const partes = nome.trim().split(' ');

    const primeiro = partes[0][0];
    const segundo = partes[partes.length - 1][0];

    return `${primeiro}.${segundo}`;
}

const CertificadoMedicamento = async (solicitacao: any, certificado: any) => {
    const date1 = new Date(certificado?.createdAt);
    const date2 = new Date(certificado?.dataExpiracao);
    const diffInMonths =
        (date2.getFullYear() - date1.getFullYear()) * 12 +
        (date2.getMonth() - date1.getMonth());
    const dataEmissao = date1.toLocaleDateString("pt-BR");
    const dataValidade = date2.toLocaleDateString("pt-BR");
    const abreviatura = abreviarNome(solicitacao?.importador?.nome);

    const imageBlob = await fetch('/img/logo/InsigniaAngola.png').then(res => res.blob());
    const imageBase64 = await getBase64Image(imageBlob) as string;
    const imageFundo = await fetch('/img/logo/logoArmed.png').then(res => res.blob());
    const imageFundo64 = await getBase64Image(imageFundo) as string;

    const certificadoData = certificado?.numeroCertificado;
    const [numero, ano] = certificadoData?.split('/') ?? [];

    pdfMake.fonts = {
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };
    const gerarConteudoPagina = () => [
        {
            columns: [
                {
                    text: '',
                    width: '45%'
                },
                {
                    image: imageBase64,
                    width: 50,
                    height: 50,
                    alignment: 'center',
                    margin: [0, 10, 0, 0],
                },
                {
                    width: '15%',
                    margin: [190, 0, 0, 0],
                    qr: `https://armed.gov.ao/verifica-documento/certificado/${certificado?._id}`,
                    fit: 70
                }
            ],
        },
        { text: 'REPÚBLICA DE ANGOLA', style: 'header', },
        { text: 'MINISTÉRIO DA SAÚDE', style: 'header', },
        { text: 'AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE', style: 'header', },
        {
            columns: [
                {
                    stack: [
                        { canvas: [{ type: 'rect', x: 17, y: 18, w: 540, h: 24, lineWidth: 1, lineColor: '#111' }] },
                        { text: `CERTIFICADO DE IMPORTAÇÃO DE ${certificado?.productoRefente?.categoria ? certificado?.productoRefente?.categoria.toUpperCase() : ''} Nº ${numero} MED/${ano}`, alignment: 'center', style: 'subheader', margin: [0, -18, 0, 0] },
                    ],
                }
            ],
        },
        { text: 'A Agência Reguladora de Medicamentos e Tecnologias de Saúde, entidade reguladora do sector farmacêutico criada pelo Decreto Presidencial nº 136/21 de 1 de Junho, emite o presente certificado conforme previsto no nº 6 do art. 12º do Decreto Presidencial nº 180/10 de 18 de Agosto, sobre a Política Nacional Farmacêutica.', style: 'declaration', },
        {
            layout: {
                hLineWidth: function () {
                    return 1;
                },
                vLineWidth: function () {
                    return 1;
                },
                hLineColor: function () {
                    return '#111';
                },
                vLineColor: function () {
                    return '#111';
                }
            },
            margin: [17, 0, 7, 0],
            table: {
                // layout: 'noBorders',
                widths: ['*'],
                body: [
                    [
                        {
                            stack: [
                                {
                                    text: 'Importador:',
                                    style: 'subheader',
                                    margin: [0, 0, 0, 5]
                                },
                                {
                                    text: `${solicitacao?.importador?.nome ?? ''}`.toUpperCase(),
                                    style: 'body',
                                    bold: true,
                                },
                                {
                                    text: `${solicitacao?.importador?.rua ?? ''}`,
                                    style: 'body',
                                },
                                {
                                    text: `${solicitacao?.importador?.provincia ?? ''} - Angola`.toUpperCase(),
                                    style: 'body',
                                    bold: true
                                }
                            ],
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            stack: [
                                {
                                    text: 'Exportador:',
                                    style: 'subheader',
                                    margin: [0, 0, 0, 5]
                                },
                                {
                                    text: `${solicitacao?.fornecedorNome ?? ''}`.toUpperCase(),
                                    style: 'body',
                                    bold: true,
                                },
                                {
                                    text: `${solicitacao?.endereco ?? ''}`,
                                    style: 'body',
                                },
                                {
                                    text: `${solicitacao?.paisOrigem ?? ''}`.toUpperCase(),
                                    style: 'body',
                                    bold: true
                                },
                                {
                                    text: [`Factura Proforma nº `,
                                        { text: `${solicitacao?.numFaturaPro ?? ''}`, bold: false }
                                    ],
                                    style: 'body',
                                    bold: true,
                                    margin: [0, 15, 0, 5]
                                }
                            ],
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            stack: [
                                {
                                    text: 'Descrição e quantidade das substáncias a autorizar:',
                                    style: 'header',
                                    alignment: "left",
                                    bold: true,
                                    margin: [0, 0, 0, 3]
                                },
                                {
                                    text: `${(certificado?.productoRefente?.quantidade || '') + ' ' + (certificado?.productoRefente?.formaFarmaceutica || '') + ' de ' + (certificado?.productoRefente?.nome || '') + ' ' + (certificado?.productoRefente?.dosagemConcentracao || '') + ' ' + (certificado?.productoRefente?.fabricante ? `- ${certificado?.productoRefente?.fabricante}` : '')}`.trim() || "—",
                                    style: 'body',
                                    alignment: "left"
                                }
                            ],
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            text: `Emitido em: ${dataEmissao}`,
                            style: 'body',
                            bold: true,
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            columns: [
                                {
                                    text: `Validade: ${dataValidade}`,
                                    style: 'body',
                                    bold: true,
                                    margin: [0, 0, 0, 0]
                                },
                            ],
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            text: 'Via de Expedição: Aérea/Maritima/Terrestre',
                            style: 'body',
                            bold: true,
                            margin: [5, 5, 5, 5]
                        }
                    ],
                    [
                        {
                            text: 'VÁLIDO PARA UMA ÚNICA IMPORTAÇÃO',
                            style: 'body',
                            alignment: 'center',
                            decoration: 'underline',
                            bold: true,
                            margin: [5, 5, 5, 5],
                            fontSize: 9,
                        }
                    ]
                ]
            },
            style: 'body'
        },
        { text: 'O DIRECTOR GERAL'.toUpperCase(), style: 'header', margin: [0, 40, 0, 0] },
    ];

    const conteudoFinal = [
        ...gerarConteudoPagina(),
        { text: '', pageBreak: 'after', id: 'certificado_break_1' } as any,
        ...gerarConteudoPagina(),
        { text: '', pageBreak: 'after', id: 'certificado_break_2' } as any,
        ...gerarConteudoPagina(),
    ] as any[];

    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [15, 40, 15, 100],
        content: conteudoFinal,

        footer: (currentPage, pageCount) => {
            // Calcula quantas páginas cada certificado ocupa
            // Como temos 3 certificados no total de pageCount páginas
            const NUMERO_CERTIFICADOS = 3;
            const paginasPorCertificado = Math.ceil(pageCount / NUMERO_CERTIFICADOS);

            // Determina qual certificado estamos (1, 2 ou 3)
            const numeroCertificado = Math.ceil(currentPage / paginasPorCertificado);

            // Calcula a página relativa dentro do certificado atual
            const paginaRelativa = currentPage - ((numeroCertificado - 1) * paginasPorCertificado);

            // Verifica se estamos no último certificado (terceiro)
            const isUltimoCertificado = numeroCertificado === NUMERO_CERTIFICADOS;

            const footerContent: any[] = [
                {
                    columns: [
                        {
                            stack: [
                                { text: '|', style: '', margin: [0, 15, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: isUltimoCertificado ? '|' : '', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: isUltimoCertificado ? '|' : '', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: isUltimoCertificado ? '|' : '', style: '', margin: [0, -6, 0, 0], bold: false },
                            ],
                            width: '2%',
                            fontSize: 9,
                            alignment: 'left'
                        },
                        {
                            stack: [
                                { text: isUltimoCertificado ? `Para uso exclusivo das alfândigas` : '', style: '', margin: isUltimoCertificado ? [-3, 10, 0, 0] : [-3, 15, 0, 0], bold: true, fontSize: 11.4, color: '#FF6211' },
                                { text: isUltimoCertificado ? '__________________________________________________________________________' : '', style: '', margin: isUltimoCertificado ? [0, -5, 0, 0] : [0, -23, 0, 0], bold: false, },
                                { text: 'Rua Cmdt. Che Guevara nº 86/86º,', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'Bº Maculusso, Ingombota', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'Tel.: +244 945 817 227', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'Email: expediente@armed.minsa.gov.ao', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'LUANDA-ANGOLA', style: '', margin: [-3, 0, 0, 0], bold: false },
                            ],
                            width: '68%',
                            fontSize: 9,
                            alignment: 'left'
                        },
                        {
                            width: '30%',
                            stack: [
                                {
                                    image: imageFundo64,
                                    width: 140,
                                    height: 40,
                                    alignment: 'center',
                                },
                            ],
                            margin: [0, 15, 0, 0],
                        },
                    ],
                    alignment: 'center',
                    fontSize: 8,
                    margin: [50, 0, 50, 0],
                }
            ];

            if (paginasPorCertificado > 1) {
                footerContent.push({
                    text: `Página ${paginaRelativa}`,
                    alignment: 'right',
                    fontSize: 9,
                    margin: [0, 3, 50, 0],
                    color: '#555'
                });
            }

            return footerContent;
        },

        /** ESTILOS DE DOCUMENTO **/
        styles: {
            header: {
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
            },
            subheader: {
                bold: true,
                alignment: 'left',
                margin: [0, 0, 0, 0],
            },
            declaration: {
                fontSize: 11,
                bold: true,
                alignment: 'justify',
                margin: [20, 15, 20, 5],
                lineHeight: 1.3,
            },
            body: {
                fontSize: 10.5,
                alignment: 'justify',
                margin: [55, 3, 50, 0],
                lineHeight: 1,
            },
            signature: {
                fontSize: 12,
                bold: false,
                margin: [0, 10, 0, 0],
            },
        },
        defaultStyle: {
            font: 'Roboto',
        }

    };

    pdfMake.createPdf(docDefinition).open();

};
export {
    CertificadoMedicamento,
}